<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .lead-owners {
    .detail {
      .editable-click {
        text-decoration: underline;
        color: $gray-dark;
        cursor: pointer;
        font-weight: 600;

        i {
          margin-left: 0.2rem;
        }
      }
    }
  }

  ::v-deep .popper[x-placement^="top"] .popper__arrow {
    border-color: $salesflow-bg-content transparent transparent transparent;
  }

  ::v-deep .popper[x-placement^="bottom"] .popper__arrow {
    border-color: transparent transparent $salesflow-bg-content transparent;
  }

  .editable-modal {
    z-index: 10;
    display: flex;
    min-width: 170px;
    text-align: left;
    padding: 16px;
    border-radius: 16px;
    background-color: $salesflow-bg-content;
    flex-direction: column;
    box-shadow: 0 5px 15px rgba(0, 0, 0, .3);

    .editable-title {
      h3 {
        color: #3b334a;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: -0.21px;
        line-height: 40px;
        text-transform: none;
      }
    }

    .editable-content {
      margin-top: 10px;

      .input-group-text {
        border: none;
        border-radius: 0;
        background: #fff;
        padding: 0.375rem 1.2rem;
        background-color: #e9ecef;
      }

      .form-control,
      .input-group-text {
        margin-bottom: 10px;
      }

      input.form-control {
        border: 1px solid $salesflow-outline-gray-medium;
        border-radius: 8px;
        background-color:white;
        padding: 1rem 0.75rem;

        @include salesflow-text;

        &::placeholder {
          color: $salesflow-outline-gray-medium;
        }
      }

      button {
        margin: 5px auto 0;
      }

      ul {
        overflow-y: auto;
        max-height: 26vh;
        padding: 0;
        margin: 0;

        &::-webkit-scrollbar {
          width: 4px;
          border-radius: 30px;
        }

        &::-webkit-scrollbar-thumb {
          background: #ccc6d6;
          border-radius: 30px;
        }
      }

      .user-list {
        display: flex;
        align-items: center;
        padding: 5px;
        border-radius: 5px;

        .user-list-item {
          display: inline-block;
          margin-right: 6px;
          @include salesflow-text;
        }

        .user-list-check {
          margin-left: auto;

          i {
            vertical-align: sub;
          }
        }

        .initials {
          display: flex;
        }

        &:hover {
          color: $salesflow-font-dark;
          background: $salesflow-outline-gray-light;
        }
      }
    }
  }
</style>

<template>
  <div class="editable">
    <div :class="['profile-detail', { pointer: can && hasMinUsers }, 'lead-owners']" @click.prevent="toggleModal()"
      v-show="users">
      <div class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14">
          <g>
            <g>
              <g>
                <path fill="#3b334a"
                  d="M7.617 1.878a2.487 2.487 0 0 1 2.48 2.48 2.487 2.487 0 0 1-2.48 2.48 2.487 2.487 0 0 1-2.48-2.48 2.487 2.487 0 0 1 2.48-2.48zm0 5.849a3.37 3.37 0 0 0 3.368-3.369A3.36 3.36 0 0 0 7.617 1a3.367 3.367 0 0 0-3.369 3.358 3.376 3.376 0 0 0 3.369 3.369z" />
                <path fill="none" stroke="#3b334a" stroke-miterlimit="50" stroke-width=".2"
                  d="M7.617 1.878a2.487 2.487 0 0 1 2.48 2.48 2.487 2.487 0 0 1-2.48 2.48 2.487 2.487 0 0 1-2.48-2.48 2.487 2.487 0 0 1 2.48-2.48zm0 5.849a3.37 3.37 0 0 0 3.368-3.369A3.36 3.36 0 0 0 7.617 1a3.367 3.367 0 0 0-3.369 3.358 3.376 3.376 0 0 0 3.369 3.369z" />
              </g>
              <g>
                <path fill="#3b334a"
                  d="M5.57 9.204h4.134c1.694 0 3.09 1.26 3.306 2.894H2.264a3.344 3.344 0 0 1 3.307-2.894zM1.79 12.986h11.697a.441.441 0 0 0 .444-.444 4.231 4.231 0 0 0-4.226-4.226H5.57a4.231 4.231 0 0 0-4.227 4.226c0 .248.197.444.445.444z" />
                <path fill="none" stroke="#3b334a" stroke-miterlimit="50" stroke-width=".2"
                  d="M5.57 9.204h4.134c1.694 0 3.09 1.26 3.306 2.894H2.264a3.344 3.344 0 0 1 3.307-2.894zM1.79 12.986h11.697a.441.441 0 0 0 .444-.444 4.231 4.231 0 0 0-4.226-4.226H5.57a4.231 4.231 0 0 0-4.227 4.226c0 .248.197.444.445.444z" />
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div class="detail">
        <!-- <Show active users>-->
        {{ title }}
        <Popper v-if="!loading" trigger="click" :options="popper.options">
          <div class="popper editable-modal">
            <div class="editable-content">
              <div class="form-group">
                <input class="form-control" type="text" placeholder="Encontrar usuário" v-model="query">
              </div>
              <ul>
                <li class="pointer user-list" v-for="maybeActive in usersOwners"
                  @click.prevent="toggleActive(maybeActive.id)">
                  <span class="user-list-item">
                    <Avatar class="circle avatar" :name="maybeActive.name" width="30" :url="maybeActive.gravatar"
                      :key="maybeActive.id" />
                  </span><span class="user-list-item">{{ maybeActive.name }}</span><span class="user-list-check">
                    <IconCheck color="#212529" size="10" v-show="isActive(maybeActive.id)" />
                  </span>
                </li>
                <li class="user-list" v-show="usersOwners.length == 0">
                  Nenhum usuário encontrado
                </li>
              </ul>
            </div>
          </div>
          <div class="users-wrapper" v-show="!loading" slot="reference">
            <div v-for="user in publicUsers" :key="user.id">
              <p class="editable-click mb-0">
                {{ user.name }}
              </p>
            </div>
            <p class="editable-click mb-0" v-show="!hasActives">
              Atribuir<i class="fa fa-angle-down" v-show="can && hasMinUsers" />
            </p>
          </div>
          <!-- </Show active users>-->
        </Popper>
        <div v-else>
          <i class="fa fa-circle-o-notch fa-spin" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import Popper from 'vue-popperjs';
import User from '../user/Users.vue';
import 'vue-popperjs/dist/vue-popper.css';

export default {

  components: {
    Popper,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  extends: User,

  props: ['lead'],

  computed: {
    usersOwners() {
      // activeUsers - usuarios que estão de dono do lead
      // users - usuários que podem ser atribuidos a Lead

      // preciso fazer o merge destes arrays sem duplicar entrada.
      const mergedArray = this.mergeUsersArray(this.actives, this.allUsers, "hashid");
      return mergedArray;
    }
  },

  data() {
    return {
      errors: {
        addUser: this.__('Falha em adicionar dono.'),
        removeUser: this.__('Falha em remover dono.'),
      },
      popper: {
        options: {
          modifiers: {
            offset: { offset: '84px,0px' },
          },
        },
      }
    };
  },

  methods: {
    mergeUsersArray(arr1, arr2, key) {
      const map = new Map();
      // Adiciona todos os itens do primeiro array ao mapa

      arr1?.forEach(item => map.set(item[key], item));

      // Adiciona itens do segundo array ao mapa, se a chave não existir
      arr2?.forEach(item => map.set(item[key], item));

      // Retorna um array com os valores únicos
      return Array.from(map.values());
    },
    store(id) {
      this.$http.put(`/lead/${this.lead}`, { toggle: id }).then(response => {
        if (response.body.detached.length > 0) {
          // this.allUsers = this.allUsers.filter(item => item.id !== id && item.role);
          this.actives = this.actives.filter(item => item.id !== id);
        }
      });
      return;
    },
  },
};
</script>
